import React, { ReactNode } from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { RightArrow } from 'src/components/SvgIcons/SvgIcons';
import { SxProps, Theme } from '@mui/material';

interface TextArrowProps {
  children: ReactNode;
  onClick?: () => void;
  cursor?: 'pointer' | 'default';
  sx?: SxProps<Theme>;
}

const TextArrow = ({ children, onClick, cursor = 'pointer', sx }: TextArrowProps) => {
  return (
    <Text
      variant="body2"
      sx={{
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center',
        cursor,
        '&:hover': {
          textDecoration: 'underline',
          '& .hover-arrow': {
            transform: 'translateX(2.5px)'
          }
        },
        width: 'fit-content',
        ...sx
      }}
      onClick={onClick}
    >
      {children}
      <RightArrow
        style={{
          marginLeft: '4px',
          height: '16px',
          width: '16px',
          transition: 'transform 0.2s ease-in-out'
        }}
        className="hover-arrow"
      />
    </Text>
  );
};

export default TextArrow;
